import { lazy } from 'react';

export const SimilarProductsJobsPageAsync = lazy(
  () => import('./SimilarProductsJobs'),
);
